module.exports = __webpack_public_path__ + "img/icon-btn-android1.6fa4aa72.png";